<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Calculadora M-CHAT-R"
    >
        <rkm-form ref="RkmForm">
            <rkm-table
                :fields="fields"
                :items="model"
                hide-filters
                hide-pagination
            >
                <template v-slot:cell(pergunta)="{index}">
                    {{index + 1}}
                </template>

                <template v-slot:cell(resposta)="{index, item}">
                    <rkm-form-radio-group
                        :validations="validations.resposta"
                        :name="`Resposta ${index + 1}`"
                        v-model="item.resposta"
                    >
                        <rkm-form-radio :value="true">Sim</rkm-form-radio>
                        <rkm-form-radio :value="false">Não</rkm-form-radio>
                    </rkm-form-radio-group>
                </template>
            </rkm-table>
        </rkm-form>

        <rkm-alert
            v-if="hasResultado"
            :color="alertColor"
            class="mt-3 mb-0"
        >
            <strong>SCORE: {{resultado}}</strong>. {{alertMessage}}
        </rkm-alert>

        <rkm-area
            title="Histórico de respostas"
            type="fieldset"
        >
            <rkm-table
                :fields="fieldsHistorico"
                :items="data.form.puericultura.questionarioMChatR"
            >
                <template v-slot:cell(actions)="{item}">
                    <rkm-button
                        @click="print(item)"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="clear"
                color="info"
            >
                Limpar formulário
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, file, object, repository} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                resposta: {required: true},
            }
        },
        hasResultado() {
            return this.model && this.model.filter(model => model.resposta !== null).length > 0
        },
        resultado() {
            return this.model && this.model
                .filter(model => model.resposta !== null)
                .reduce((total, model) => total + (model.resposta ? model.valorRespostaSim : model.valorRespostaNao), 0)
        },
        alertColor() {
            let color = ''

            if (this.hasResultado && this.resultado >= 0 && this.resultado <= 2) {
                color = 'success'
            }
            else if (this.hasResultado && this.resultado >= 3 && this.resultado <= 7) {
                color = 'warning'
            }
            else if (this.hasResultado && this.resultado >= 8) {
                color = 'danger'
            }

            return color
        },
        alertMessage() {
            let message = ''

            if (this.resultado >= 0 && this.resultado <= 2) {
                if (this.data.form.paciente.idadeEmMeses < 24) {
                    message = 'Resultado classificado como Baixo risco pelo M-CHAT-R™. Instrumento de triagem, não diagnóstico. Recomenda-se reaplicação após a criança completar 24 meses, mantendo acompanhamento do desenvolvimento.'
                } else {
                    message = 'Resultado classificado como Baixo risco pelo M-CHAT-R™. Instrumento de triagem, não diagnóstico. Manter acompanhamento de rotina do desenvolvimento infantil.'
                }
            }
            else if (this.resultado >= 3 && this.resultado <= 7) {
                message = 'Resultado classificado como Risco moderado pelo M-CHAT-R™. Instrumento de triagem, não diagnóstico. Recomenda-se aplicação da entrevista de seguimento (M-CHAT-R/F) para refinamento do resultado e definição de conduta.'
            }
            else if (this.resultado >= 8) {
                message = 'Resultado classificado como Alto risco pelo M-CHAT-R™. Instrumento de triagem, não diagnóstico. Recomenda-se avaliação clínica e definição de conduta conforme rede assistencial.'
            }

            return message
        },
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
        }
    },
    data: () => ({
        fields: [
            {class: 'col-min text-center', key: 'pergunta', label: '#'},
            {key: 'descricao', label: 'Pergunta'},
            {class: 'col-min text-center', key: 'resposta', label: 'Resposta'},
        ],
        fieldsHistorico: [
            {key: 'dataHoraAtendimento', label: 'Data/Hora'},
            {key: 'usuarioNome', label: 'Profissional'},
            {key: 'score', label: 'Score'},
            {key: 'classificacao', label: 'Classificação'},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
        items: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(items) {
            this.items = items

            this.create()

            this.$refs.RkmModal.show()
        },
        create() {
            this.model = this.clone(this.items)
        },
        store() {
            this.data.model.puericultura.questionarioMChatR = this.model
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.store()

                    this.$refs.RkmModal.hide()
                })
        },
        clear() {
            this.model.map(model => model.resposta = null)

            this.data.model.puericultura.questionarioMChatR = this.model

            this.$refs.RkmModal.hide()
        },
        print(item) {
            this.setLoading()

            this.repositories.impressao.laudoMChatR(item.atendimentoId, item.soapId)
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, file, object, repository],
    props: {
        data: {type: Object, required: true},
    },
}
</script>